var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquiggledLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3665B0"
    },
    d: "M290.068,512.001c-9.426,0-17.067-7.642-17.067-17.067V329.486c0-9.426,7.642-17.067,17.067-17.067 s17.067,7.642,17.067,17.067v165.446C307.135,504.359,299.493,512.001,290.068,512.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3665B0"
    },
    d: "M386.952,435.141c-29.849,0-54.134-24.285-54.134-54.135V246.603 c0-9.426,7.642-17.067,17.067-17.067s17.067,7.642,17.067,17.067v134.404c0,11.028,8.972,20,19.999,20s20-8.973,20-20v-62.567 c0-9.426,7.642-17.067,17.067-17.067h42.754c9.426,0,17.067,7.642,17.067,17.067s-7.642,17.067-17.067,17.067h-25.687v45.499 C441.087,410.855,416.801,435.141,386.952,435.141z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#143466"
    },
    d: "M327.778,218.495l-53.767-149.29c-6.03-16.742,14.64-30.478,27.717-18.247l105.787,98.968 c24.792,23.196,12.985,64.78-20.309,71.474l-40.007,8.043C338.868,231.116,330.633,226.424,327.778,218.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#143466"
    },
    d: "M221.932,512.001c-9.426,0-17.067-7.642-17.067-17.067V329.486c0-9.426,7.642-17.067,17.067-17.067 s17.067,7.642,17.067,17.067v165.446C238.999,504.359,231.359,512.001,221.932,512.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#143466"
    },
    d: "M125.049,435.141c-29.849,0-54.135-24.285-54.135-54.135v-45.5H45.227 c-9.426,0-17.067-7.642-17.067-17.067s7.642-17.067,17.067-17.067h42.754c9.426,0,17.067,7.642,17.067,17.067v62.566 c0,11.028,8.973,20,20,20s19.999-8.973,19.999-20V246.603c0-9.426,7.642-17.067,17.067-17.067s17.067,7.642,17.067,17.067v134.404 C179.183,410.855,154.898,435.141,125.049,435.141z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2672ED"
    },
    d: "M164.801,229.446l-40.006-8.043c-33.283-6.693-45.107-48.273-20.308-71.474l105.785-98.968 c12.99-12.151,33.786,1.397,27.717,18.247l-53.766,149.287C181.365,226.429,173.125,231.115,164.801,229.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66A1FF"
    },
    d: "M256,352.699c-28.247,0-56.493-10.42-78.504-31.264c-30.18-28.579-40.422-72.762-26.09-112.558 L216.69,27.61c13.265-36.829,65.367-36.798,78.62,0l65.284,181.266c14.333,39.797,4.092,83.979-26.09,112.559 C312.494,342.279,284.247,352.699,256,352.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2672ED"
    },
    d: "M360.595,208.876L295.311,27.611C288.683,9.21,272.342,0.003,256,0.001v352.698 c28.246,0,56.493-10.42,78.504-31.264C364.685,292.856,374.926,248.673,360.595,208.876z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F9FF"
    },
    cx: 209.334,
    cy: 277.319,
    r: 22.578
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F9FF"
    },
    cx: 302.669,
    cy: 277.319,
    r: 22.578
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquiggledLogo);
export default __webpack_public_path__ + "static/media/squiggled-logo.aafcf953070e0d22418a92b2b80180b4.svg";
export { ForwardRef as ReactComponent };